(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["grabbr-reel-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grabbr-reels')) {
    class GrabbrReels extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.viewport = this.querySelector('[data-reel-viewport]');
        if (!this.viewport) return;
        this.initialized = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.cards = Array.from(this.querySelectorAll('[data-reel-card]'));
        this.videos = Array.from(this.querySelectorAll('[data-reel-video]'));
        this.previous = this.querySelector('[data-reel-previous]');
        this.next = this.querySelector('[data-reel-next]');
        this.setAttribute('data-ready', '');
        this.querySelectorAll('[data-reel-play]').forEach((button) => { button.hidden = false; });
        this.addEventListener('click', (event) => {
          if (this.didDrag) { event.preventDefault(); this.didDrag = false; return; }
          const play = event.target.closest('[data-reel-play]');
          if (play) { this.play(play.closest('[data-reel-card]')); return; }
          if (event.target.closest('[data-reel-next]')) this.goTo(this.position() + 1);
          if (event.target.closest('[data-reel-previous]')) this.goTo(this.position() - 1);
          const dot = event.target.closest('[data-reel-index]');
          if (dot) this.goTo(Number(dot.dataset.reelIndex));
        }, options);
        this.videos.forEach((video) => {
          video.tabIndex = -1;
          const media = video.closest('[data-reel-media]');
          video.addEventListener('play', () => { this.videos.forEach((other) => { if (other !== video) other.pause(); }); }, options);
          video.addEventListener('playing', () => { media.querySelector('[data-reel-loading]').hidden = true; }, options);
          video.addEventListener('waiting', () => { if (!video.paused) media.querySelector('[data-reel-loading]').hidden = false; }, options);
          video.addEventListener('pause', () => { media.querySelector('[data-reel-loading]').hidden = true; }, options);
          video.addEventListener('ended', () => { media.classList.remove('is-active'); media.querySelector('[data-reel-play]').hidden = false; video.tabIndex = -1; video.currentTime = 0; }, options);
          video.addEventListener('error', () => this.showError(media), options);
        });
        this.viewport.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.position() + (event.key === 'ArrowRight' ? 1 : -1)); }
        }, options);
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('video, button')) return;
          this.drag = { x: event.clientX, scroll: this.viewport.scrollLeft, id: event.pointerId };
          this.didDrag = false;
        }, options);
        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.drag) return;
          const distance = event.clientX - this.drag.x;
          if (Math.abs(distance) < 6 && !this.didDrag) return;
          this.didDrag = true;
          this.viewport.classList.add('is-dragging');
          if (!this.viewport.hasPointerCapture(this.drag.id)) this.viewport.setPointerCapture(this.drag.id);
          this.viewport.scrollLeft = this.drag.scroll - distance;
        }, options);
        const stopDrag = () => { this.drag = null; this.viewport.classList.remove('is-dragging'); };
        this.viewport.addEventListener('pointerup', stopDrag, options);
        this.viewport.addEventListener('pointercancel', stopDrag, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.viewport);
        this.visibility = new IntersectionObserver((entries) => { entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }); }, { root: this.viewport, threshold: .2 });
        this.videos.forEach((video) => this.visibility.observe(video));
        this.pageVisibility = new IntersectionObserver((entries) => { if (!entries[0].isIntersecting) this.videos.forEach((video) => video.pause()); }, { threshold: .05 });
        this.pageVisibility.observe(this);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach((video) => video.pause()); }, options);
        this.update();
      }
      play(card) {
        const media = card.querySelector('[data-reel-media]');
        const video = card.querySelector('[data-reel-video]');
        media.querySelector('[data-reel-error]').hidden = true;
        media.querySelector('[data-reel-loading]').hidden = false;
        media.querySelector('[data-reel-play]').hidden = true;
        media.classList.add('is-active');
        video.tabIndex = 0;
        video.focus({ preventScroll: true });
        video.play().catch((error) => { if (error.name !== 'AbortError') this.showError(media); });
      }
      showError(media) {
        media.classList.remove('is-active');
        media.querySelector('[data-reel-loading]').hidden = true;
        media.querySelector('[data-reel-play]').hidden = false;
        media.querySelector('[data-reel-error]').hidden = false;
      }
      position() {
        const left = this.viewport.scrollLeft;
        let result = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => { const value = Math.abs(card.offsetLeft - this.cards[0].offsetLeft - left); if (value < distance) { distance = value; result = index; } });
        return result;
      }
      goTo(index) {
        const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, index))];
        if (card) this.viewport.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }
      update() {
        const scrollable = this.viewport.scrollWidth > this.viewport.clientWidth + 2;
        const position = this.position();
        this.querySelector('[data-reel-arrows]').hidden = !scrollable;
        this.querySelector('[data-reel-navigation]').hidden = !scrollable;
        this.previous.disabled = this.viewport.scrollLeft <= 2;
        this.next.disabled = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;
        this.querySelector('[data-reel-position]').textContent = String(position + 1);
        this.querySelectorAll('[data-reel-index]').forEach((dot, index) => { if (index === position) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.pageVisibility?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.videos?.forEach((video) => video.pause());
        this.initialized = false;
      }
    }
    customElements.define('grabbr-reels', GrabbrReels);
  }
  } catch(e) { console.error(e); }
})();

})();
